import React from 'react';
import { Card, CardHeader, ProgressBar, Skeleton } from '@opendate-app/setlist';
import { buildFunnel, formatPercent } from '../../utils/dashboardUtils';
import { ComingSoonBadge } from './ComingSoonCard';

function Stat({ label, value, caption }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <span style={{ fontSize: 12, color: 'var(--sl-text-tertiary)' }}>{label}</span>
      <span style={{ fontSize: 20, fontWeight: 700, color: 'var(--sl-text-primary)' }}>{value}</span>
      {caption && <span style={{ fontSize: 12, color: 'var(--sl-text-tertiary)' }}>{caption}</span>}
    </div>
  );
}

function BookingPipelineCard({ booking, kpis, loading, dateModeLabel, crossBasis, href }) {
  return (
    <Card header={<CardHeader title={<a href={href} style={{ color: 'inherit' }}>Booking pipeline →</a>} supportingText={dateModeLabel} />}>
      {loading ? <Skeleton width="100%" height={180} /> : (
        <>
          {buildFunnel(booking || {}, kpis || {}, { crossBasis }).map((step) => (
            <div key={step.label} style={{ display: 'grid', gridTemplateColumns: '88px 1fr 56px 40px', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: 'var(--sl-text-secondary)' }}>{step.label}</span>
              <ProgressBar value={step.width} />
              <strong style={{ fontSize: 13, textAlign: 'right' }}>{step.count.toLocaleString()}</strong>
              <span style={{ fontSize: 12, color: 'var(--sl-text-tertiary)', textAlign: 'right' }}>
                {step.conversion == null ? '' : `${step.conversion}%`}
              </span>
            </div>
          ))}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12, marginTop: 16, paddingTop: 16, borderTop: '1px solid var(--sl-border-secondary)' }}>
            <Stat label="Hold → confirm" value={formatPercent(booking?.hold_to_confirm_rate)} caption="of holds" />
            <Stat label="Offer acceptance" value={formatPercent(booking?.offer_acceptance_rate)} caption="of offers sent" />
            <Stat label="Open avails" value={<ComingSoonBadge />} />
          </div>
        </>
      )}
    </Card>
  );
}

export default BookingPipelineCard;
